let previousScrollPosition = 0

export const isScrollingUp = () => {
  let goingUp = false
  let scrollPosition = window.scrollY

  if (scrollPosition < previousScrollPosition) {
    goingUp = true
  }

  previousScrollPosition = scrollPosition
  return goingUp
}
